<template>
<div class="flex justify-end items-center relative">
  <div
    class="relative align-left outline-none leading-8"
    tabindex=0
    @blur="open = false"
  >
    <div
      class="bg-beige-academy-100 text-black text-left pl-4
            cursor-pointer w-64 border border-grey-academy-150 rounded"
      :class="{open: open}"
      @click="open = !open"
    >
      {{ selected }}
    </div>
    <div v-if="!overflow"
      class="text-black rounded border text-left
            border-grey-academy-150 w-64 absolute bg-beige-academy-100 z-10"
      :class="{selectHide: !open}"
    >
      <div
        class="item text-black pl-4 cursor-pointer px-20"
        v-for="(option, i) of options"
        :key="i"
        @click="changeSelected(option)"
      >
        {{ option }}
      </div>
    </div>
    <div v-else>
      <div v-if="!large"
        class="text-black rounded overflow-auto border text-left
              border-grey-academy-150 w-64 h-64 bg-beige-academy-100 z-10 absolute"
        :class="{selectHide: !open}"
      >
        <div
          class="item text-chocolate-academy-600 pl-4 cursor-pointer px-20"
          v-for="(option, i) of options"
          :key="i"
          @click="changeSelected(option)"
        >
          {{ option }}
        </div>
      </div>
      <div v-else
        class="text-black rounded border text-left absolute border-grey-academy-150
              w-auto overflow-auto h-64 bg-beige-academy-100 z-10"
        :class="{selectHide: !open}"
      >
        <div
          class="item text-black pl-4 cursor-pointer px-20"
          v-for="(option, i) of options"
          :key="i"
          @click="changeSelected(option)"
        >
          {{ option }}
        </div>
      </div>
    </div>
  </div>
  <div class="pointer-events-none absolute inset-y-0
  right-0 flex items-center px-1 pt-1 text-black">
    <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
      <path d="M9.293 12.95l.707.707L15.657
      8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
    </svg>
  </div>
</div>
</template>

<script>
export default {
  props: ['options', 'value', 'isLarge', 'hasOverflow'],

  data() {
    return {
      open: false,
      selected: this.value,
      large: this.isLarge ? this.isLarge : false,
      overflow: this.hasOverflow ? this.hasOverflow : false,
    };
  },

  methods: {
    changeSelected(option) {
      this.selected = option;
      this.open = false;
      this.$emit('input', option);
    },
  },

};
</script>

<style scoped>

.item:hover {
  background-color: white;
}

.selectHide {
  display: none;
}
</style>
